export enum EventModelView {
    CREATE_EVENT,
    UPDATE_EVENT,
    DELETE_EVENT,
}